import { Directive, Input, TemplateRef } from '@angular/core';

import { DataTableCellContext } from './data-table.types';

/**
 * Marks an ng-template as the cell renderer for a data-table column key.
 *
 * @example
 * <ng-template appDataTableCell="status" let-row let-value="value">...</ng-template>
 */
@Directive({
  selector: '[appDataTableCell]',
  standalone: true,
})
export class DataTableCellDefDirective<T = unknown> {
  @Input({ alias: 'appDataTableCell', required: true }) columnKey = '';

  constructor(public readonly templateRef: TemplateRef<DataTableCellContext<T>>) {}
}
